import { Right } from "core/blueprint/base/BlueprintService";

export function mergeRights(rights: Right[]): Right | undefined {
	if (rights.includes(Right.ADMIN)) {
		return Right.ADMIN;
	} else if (rights.includes(Right.WRITE)) {
		return Right.WRITE;
	} else if (rights.includes(Right.READ)) {
		return Right.READ;
	} else {
		return undefined;
	}
}

export function splitRight(right: Right | undefined): Right[] {
	switch (right) {
		case Right.ADMIN:
			return [Right.ADMIN, Right.WRITE, Right.READ];
		case Right.WRITE:
			return [Right.WRITE, Right.READ];
		case Right.READ:
			return [Right.READ];
		default:
			return [];
	}
}
